import { Component, Input } from '@angular/core';

@Component({
    selector: 'ef-column-search',
    templateUrl: './column-search.component.html',
    styleUrls: ['./column-search.component.scss'],
    standalone: false
})
export class ColumnSearchComponent {
    columnSearchValue: string | null;
    columnIndex: number | null;
    @Input() elements: HTMLCollectionOf<Element>;
    filteredElements: Array<any>;
    icon = 'pi pi-search';
    oldEle: any;
    clearSearch() {
        this.columnSearchValue = null;
        this.columnIndex = null;
        this.icon = 'pi pi-search';

        if (this.oldEle != null) {
            this.oldEle.style.color = 'white';
        }
    }

    searchTextChanged() {
        this.columnIndex = null;
        this.icon = 'pi pi-search';
    }
    scrollToColumn(id) {
        if (this.oldEle != null) {
            this.oldEle.style.color = 'white';
        }

        //var elements = document.getElementsByClassName('p-header-cell');
        let ele;
        const elementsArr = Array.from(this.elements);
        this.filteredElements = elementsArr.filter(x =>
            x.textContent
                ?.toLowerCase()
                .trim()
                .includes(id.toLowerCase().trim())
        );
        for (let i = 0; i < this.filteredElements.length; i++) {
            if (this.columnIndex != null) {
                if (i > +this.columnIndex) {
                    ele = this.filteredElements[i];
                    this.columnIndex = i;
                    ele.style.color = 'yellow';
                    ele.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                    this.oldEle = ele;
                    if (this.filteredElements.length - 1 == i) {
                        this.columnIndex = null;
                    }
                    break;
                }
            } else {
                if (this.filteredElements[i]) {
                    ele = this.filteredElements[i];
                    this.columnIndex = i;
                    ele.style.color = 'yellow';
                    ele.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                    this.oldEle = ele;
                    break;
                }
            }
        }
        if (this.filteredElements.length > 1) {
            this.icon = 'pi pi-angle-right';
        } else {
            this.icon = 'pi pi-search';
        }
    }
}
